import { render, staticRenderFns } from "./OrderNumbers.vue?vue&type=template&id=2399c666&scoped=true"
import script from "./OrderNumbers.vue?vue&type=script&lang=ts"
export * from "./OrderNumbers.vue?vue&type=script&lang=ts"
import style0 from "./OrderNumbers.vue?vue&type=style&index=0&id=2399c666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399c666",
  null
  
)

export default component.exports